<template>
  <div class="wa-upload">
    <v-container style="padding: 12px;max-width: 100%">
      <v-tabs
          v-model="tab"
          grow
          background-color="transparent"
      >
        <v-tab style="width: 25%" v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-card
          color="basil"
          flat
      >
        <v-card-text style="padding: 0 16px;">
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div style="width: 30%;padding: 16px 0!important;">
              <v-row>
                <v-col :cols="8" style="padding: 0 12px">
                  <v-card-title style="padding: 0 16px 0 0;font-size: 1rem">Upload</v-card-title>
                </v-col>
                <v-col :cols="4" style="padding: 0 12px;text-align: right">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <a :href="templateFileUrl">
                        <v-btn
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon>cloud_download</v-icon>
                        </v-btn>
                      </a>
                    </template>
                    <span>Download Template</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="12">
                  <v-select
                      v-if="tab === 0"
                      v-model="collectionProvider"
                      :items="collectionProviderList"
                      label="External Collection Provider"
                      hide-details
                  ></v-select>
                  <v-select
                      v-else-if="tab === 3"
                      v-model="collectionProvider"
                      :items="uploadBalanceFileList"
                      label="External Collection Provider"
                      hide-details
                  ></v-select>
                  <v-select
                      v-else
                      v-model="collectionProvider"
                      :items="collectionProviderPaymentFiles"
                      label="External Collection Provider"
                      hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row style="padding: 0 5px 0 10px" v-if="uploadBtnDisplay">
                <files-upload ref="fileupload" type="single" :number="tab"></files-upload>
                <v-btn color="primary" style="margin: 12px auto" @click="uploadFile">
                  Upload
                </v-btn>
              </v-row>
            </div>
            <div style="width: 1%;padding: 10px 0;text-align: center">
              <v-divider vertical></v-divider>
            </div>
            <div style="width: 67%;padding: 16px 0">
              <v-row>
                <v-card-title style="padding: 0 16px;font-size: 1rem;">{{ tableTitle }}</v-card-title>
                <v-col :cols="12" style="max-width: 150%!important;">
                  <v-data-table
                      :headers="dataSource.headers"
                      :items="dataSource.items"
                      loading-text="Loading... Please wait"
                      :loading="dataSource.loading"
                      :options.sync="dataSource.dataOptions"
                      :server-items-length="dataSource.dataOptions.pageCount"
                      :footer-props="dataSource.footerProps"
                      fixed-header
                      class="elevation-1"
                      height="300"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                          v-if="item.status === 1"
                          class="ma-2"
                          label
                          color="success"
                          small
                      >
                        Success
                      </v-chip>
                      <v-chip
                          v-else
                          class="ma-2"
                          label
                          color="error"
                          small
                      >
                        Failure
                      </v-chip>
                    </template>
                    <template v-slot:item.data="{ item }">
                      <v-chip
                          class="ma-2"
                          label
                          color="warning"
                          @click="detailsDialog(item)"
                          small
                      >
                        Details
                      </v-chip>
                    </template>
                    <template v-slot:item.fileUrl="{ item }">
                      <a :href="item.fileUrl">
                        <v-btn color="primary" x-small>
                          Download
                        </v-btn>
                      </a>
                    </template>
                    <template v-slot:item.transactionDate="{ item }">
                      {{ item.transactionDate }}
                    </template>
                    <template v-slot:item.operatedBy="{ item }">
                      {{ assist.tool.formatOperatedBy(item.operatedBy) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dataSource.dialog.display" width="800px" persistent>
        <v-card v-if="dataSource.dialog.display">
          <v-card-title>
            <span>Return File View</span>
            <v-spacer></v-spacer>
            <v-icon @click="dataSource.dialog.display = false">
              close
            </v-icon>
          </v-card-title>
          <v-card-text>
            <v-data-table
                loading-text="Loading... Please wait"
                :headers="dataSource.dialog.headers"
                :items="dataSource.dialog.items"
                :options.sync="dataSource.dialog.dataOptions"
                :server-items-length="dataSource.dialog.dataOptions.pageCount"
                :footer-props="dataSource.footerProps"
                fixed-header
                class="elevation-1"
                height="300"
            >
              <template v-slot:item.errorType="{ item }">
                <v-chip
                    v-if="item.errorType === 0"
                    class="ma-2"
                    label
                    color="success"
                    small
                >
                  Success
                </v-chip>
                <v-chip
                    v-else-if="item.errorType === 1"
                    class="ma-2"
                    label
                    color="error"
                    small
                >
                  Failure
                </v-chip>
                <v-chip
                    v-else
                    class="ma-2"
                    label
                    color="warning"
                    small
                >
                  Failure
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import FilesUpload from '@/components/panda/collection/detail/FilesUpload'
import { LCS_DETAIL_LAYOUT_SETTING } from '@/setting/layout/collection/detail/index'
import { Tool, DataType, Popup } from '@/util/index'
import { CollectionApi } from '@/api/lms/collection'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'Upload',
  components: {
    FilesUpload
  },
  data () {
    return {
      assist: {
        tool: tool,
        dataType: DataType
      },
      tab: 0,
      items: [
        'Upload Payment File', 'Upload Reject File', 'Upload Paid Off File', 'Upload New Balance File'
      ],
      tableTitle: 'Payment File',
      collectionProvider: DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value,
      collectionProviderList: [
        DataType.CollectionProviderEnum.WAGE_ASSIGNMENT, DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE,
        DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT, DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT,
        { value: 20003, text: 'Third Party Payment Uploader' }
      ],
      uploadBalanceFileList: [DataType.CollectionProviderEnum.BALANCE_UPDATE_UPLOADER],
      collectionProviderPaymentFiles: [
        DataType.CollectionProviderEnum.WAGE_ASSIGNMENT, DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE,
        DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT, DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT
      ],
      portfolioList: [],
      returnType: DataType.WAReturnTypeEnum.PAYMENT.value,
      templateFileUrl: 'https://storage.sztus.com/D5129E286DB74E8A835F105C42201BB5/documents/uploadPaymentFileTemplate.csv',
      dataSource: {
        headers: LCS_DETAIL_LAYOUT_SETTING.WA_UPLOAD.headers,
        items: [],
        loading: false,
        dialog: {
          display: false,
          headers: LCS_DETAIL_LAYOUT_SETTING.WA_UPLOAD.itemHeaders,
          items: [],
          dataOptions: {
            itemsPerPage: 5,
            page: 1,
            pageCount: 0
          },
          currentItem: null
        },
        dataOptions: {
          itemsPerPage: 5,
          page: 1,
          pageCount: 0
        },
        footerProps: {
          'items-per-page-options': [5, 10, 15]
        }
      },
      uploadBtnDisplay: false
    }
  },
  watch: {
    tab (val) {
      this.itemChange()
      switch (val) {
        case 0:
          this.templateFileUrl = 'https://storage.sztus.com/D5129E286DB74E8A835F105C42201BB5/documents/uploadPaymentFileTemplate.csv'
          this.tableTitle = 'Payment File'
          this.returnType = DataType.WAReturnTypeEnum.PAYMENT.value
          break
        case 1:
          this.templateFileUrl = 'https://storage.sztus.com/D5129E286DB74E8A835F105C42201BB5/documents/uploadRejectFileTemplate.csv'
          this.tableTitle = 'Reject File'
          this.returnType = DataType.WAReturnTypeEnum.REJECT.value
          break
        case 2:
          this.templateFileUrl = 'https://storage.sztus.com/D5129E286DB74E8A835F105C42201BB5/documents/uploadPaidOffFileTemplate.csv'
          this.tableTitle = 'Paid Off File'
          this.returnType = DataType.WAReturnTypeEnum.PAID_OFF.value
          break
        case 3:
          this.templateFileUrl = 'https://storage.sztus.com/D5129E286DB74E8A835F105C42201BB5/documents/uploadBalanceFileTemplate.csv'
          this.tableTitle = 'Balance File'
          this.returnType = DataType.WAReturnTypeEnum.PAID_OFF.value
          this.collectionProvider = DataType.CollectionProviderEnum.BALANCE_UPDATE_UPLOADER.value
          break
      }
      this.initReturnFile()
    },
    collectionProvider (val) {
      this.itemChange()
      this.initReturnFile()
    },
    'dataSource.dataOptions.itemsPerPage' () {
      this.initReturnFile()
    },
    'dataSource.dataOptions.page' () {
      this.initReturnFile()
    },
    'dataSource.dialog.dataOptions.itemsPerPage' () {
      this.initReturnFileItem(this.dataSource.dialog.currentItem)
    },
    'dataSource.dialog.dataOptions.page' () {
      this.initReturnFileItem(this.dataSource.dialog.currentItem)
    },
    '$store.getters.getRuntimePortfolio': {
      handler: function (newVal, oldVal) {
        if (tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.initReturnFile()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.itemChange()
  },
  methods: {
    itemChange () {
      if (this.collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value && this.tab !== 3) {
        this.uploadBtnDisplay = false
      } else {
        this.uploadBtnDisplay = true
      }
    },
    initReturnFile () {
      const fileUpload = this.$refs.fileupload
      if (fileUpload !== undefined) {
        fileUpload.clearFile()
      }
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        popup.popupForWarning('Please select portfolio')
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }

      const collectionProvider = this.collectionProvider
      let taskType
      switch (this.tab) {
        case 1: {
          if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_REJECT_TASK_FOR_WA.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_REJECT_TASK_FOR_WAI.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value
          }
          break
        }
        case 2: {
          if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_PAID_OFF_TASK_FOR_WA.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_PAID_OFF_TASK_FOR_WAI.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value
          }
          break
        }
        case 3: {
          if (collectionProvider === DataType.CollectionProviderEnum.BALANCE_UPDATE_UPLOADER.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_NEW_BALANCE.value
          }
          break
        }
        default: {
          if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_CHECK_TASK_FOR_WA.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_CHECK_TASK_FOR_WAI.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value
          } else if (collectionProvider === DataType.CollectionProviderEnum.THIRD_PARTY.value) {
            taskType = DataType.TaskTypeEnum.EXTERNAL_CHECK_TASK_FOR_PAY_DIT.value
          }
          break
        }
      }

      this.dataSource.loading = true
      const input = {
        pageNum: this.dataSource.dataOptions.page,
        pageSize: this.dataSource.dataOptions.itemsPerPage,
        portfolioList: this.$store.getters.getRuntimePortfolio,
        taskType: taskType
      }
      const _this = this
      CollectionApi.getTransactionTask(
        input,
        function (result) {
          _this.getTransactionTaskCallback(result)
        },
        function () {
          _this.dataSource.loading = false
        }
      )
    },
    initReturnFileItem (item) {
      this.dataSource.dialog.loading = true
      const input = {
        pageNum: this.dataSource.dialog.dataOptions.page,
        pageSize: this.dataSource.dialog.dataOptions.itemsPerPage,
        taskId: item.id
      }
      const _this = this
      CollectionApi.getTransactionTaskToItem(
        input,
        function (result) {
          _this.getTransactionTaskToItemCallback(result)
        },
        function () {
          _this.dataSource.dialog.loading = false
        }
      )
    },
    uploadFile () {
      // eslint-disable-next-line no-unused-vars
      if (tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        popup.popupForWarning('Please select portfolio')
        return
      }
      if (this.$store.getters.getRuntimePortfolio.length > 1) {
        popup.popupForWarning('Only one portfolio can be selected in this page')
        return
      }
      let returnFile = null
      const file = this.$refs.fileupload.saveFile()
      if (tool.isNotEmpty(file)) {
        for (const i of file) {
          // File TO FilesUpload Components
          returnFile = i.file
        }
        const portfolioId = this.$store.getters.getRuntimePortfolio[0]
        const input = {
          file: returnFile,
          portfolioId: portfolioId,
          returnType: this.returnType,
          collectionProvider: this.collectionProvider
        }
        const transactionDate = ['FL', 'WSL', 'ELL', 'NL']
        // eslint-disable-next-line no-unused-vars
        var transactionProvider = null
        for (const item of DataType.Portfolio) {
          if (item.value === portfolioId) {
            if (transactionDate.includes(item.code)) {
              transactionProvider = DataType.transactionProvider.LPP_DEBIT_CARD_PAY_DIT_PROVIDER.value
            }
            if (item.code === 'RNL') {
              transactionProvider = DataType.transactionProvider.VIKING_DEBIT_CARD_PAY_DIT_PROVIDER.value
            }
          }
        }
        const CProvider = [
          DataType.CollectionProviderEnum.EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT.value, DataType.CollectionProviderEnum.EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT.value
        ]
        if (CProvider.includes(this.collectionProvider)) {
          const $this = this
          const payload = {
            multipartFile: returnFile,
            collectionProvider: $this.collectionProvider,
            portfolioId: portfolioId,
            transactionProvider: transactionProvider
          }
          CollectionApi.uploadMultipartFile(payload, () => {
            $this.popSweetAlert('success', 'Upload Success')
            $this.initReturnFile()
          },
          function (error) {
            if (tool.isNotEmpty(error.message)) {
              $this.popSweetAlert('error', error.message)
            }
          })
        } else if (this.collectionProvider === DataType.CollectionProviderEnum.BALANCE_UPDATE_UPLOADER.value) {
          const $this = this
          const data = {
            file: returnFile,
            portfolioId: portfolioId
          }
          CollectionApi.uploadBalanceFile(data, (res) => {
            $this.popSweetAlert('success', 'Upload Success')
            $this.initReturnFile()
          }, function (err) {
            $this.popSweetAlert('error', err.message)
          })
        } else {
          const _this = this
          CollectionApi.uploadReturnFile(
            input,
            function () {
              _this.popSweetAlert('success', 'Upload Success')
              _this.initReturnFile()
            },
            function (error) {
              if (tool.isNotEmpty(error.message)) {
                _this.popSweetAlert('error', error.message)
              }
            }
          )
        }
      } else {
        this.popSweetAlert('warning', 'Please select file upload')
      }
    },
    detailsDialog (item) {
      this.dataSource.dialog.currentItem = item
      this.initReturnFileItem(item)
      this.dataSource.dialog.display = true
    },
    getTransactionTaskCallback (data) {
      this.dataSource.dataOptions.pageCount = data.total
      this.dataSource.items = data.data
      this.dataSource.loading = false
    },
    getTransactionTaskToItemCallback (data) {
      this.dataSource.dialog.dataOptions.pageCount = data.total
      this.dataSource.dialog.items = data.data
      this.dataSource.dialog.loading = false
    },
    popSweetAlert (type, tips) {
      this.$swal({
        type: type,
        text: tips,
        showCancelButton: false
      })
    }
  }
}
</script>

<style scoped>
.v-tab {
  text-transform: capitalize;
}
</style>
